import React from 'react';
import { Link } from 'react-router-dom';
import './TeamMember.css';
import { TfiEmail } from "react-icons/tfi";
import { CiEdit } from "react-icons/ci";


function TeamMember({ title, files, position, disc, email, id }) {
    // const apiUrl = 'http://localhost/server/testServer/team.php';
    const apiUrl = 'https://www.albarede.com/server/team.php';

    const isLoggedIn = localStorage.getItem('isLoggedIn');

    const changePhoto = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        if (!title || !position || !disc || !email) {
            alert('Please fill out all required fields.');
            return; // التوقف عن الإرسال إذا كانت إحدى القيم فارغة
        }
        const formData = new FormData();
        formData.append('title', title);
        formData.append('position', position);
        formData.append('disc', disc);
        formData.append('email', email);
        if (file) {
            formData.append('files', file);
        }
        try {
            const response = await fetch(`${apiUrl}?id=${id}`, {
                method: 'PUT',
                body: formData,
            });
    
            const result = await response.json(); // تحليل الرد من الخادم
    
            if (!response.ok || result.error) {
                alert(`Error: ${result.error || 'Failed to update photo'}`);
                return;
            }
    
            alert('تم تحديث الصورة بنجاح');
            window.location.reload();
        } catch (err) {
            console.error('Error updating photo:', err);
            alert('Failed to update photo.');
        }
    };


    return (
        <div className="team-item">
            <div className="team-toplayer">
                <div className='imgHolderTeam'><img src={files} alt="Team Member" /></div>
                <div>
                    <h3>{title}</h3>
                    <span>{position}</span>
                </div>
            </div>
            <p className="team-item-desc">{disc}</p>
            <a href={`mailto:${email}`}>{email} <TfiEmail /></a>
            {isLoggedIn && (
                <>
                <Link className='editBtn' to={`/editMember/${id}`} target='_top'><CiEdit /></Link>
                </>
            )}
        </div>
    );
}

export default TeamMember;
